import { appType } from "@/shared/lib/appType";

// 카카오 CS 채널(고객센터). 채널 공개 ID·URL 은 이 파일 전용 단일 값이라 별도 config/토큰으로
// 빼지 않고 인라인한다(프로젝트 규칙: 단일 일회성 값 토큰화 금지).
const CS_CHANNEL_PUBLIC_ID = "_RhixnX";
const CS_CHANNEL_WEB_URL = `https://pf.kakao.com/${CS_CHANNEL_PUBLIC_ID}/chat`;

// AOS: intent:// 로 카카오톡 앱에 위임한다.
//   ▸ 네이티브 계약(확정): intent + package=com.kakao.talk 는 ExternalAppLauncher 가 외부 앱으로
//     위임하고, 미설치 시 market:// 폴백을 탄다. (평문 http 는 usesCleartextTraffic=false 로 로드
//     자체가 차단되고, kakaoplus://·kakaotalk:// 커스텀 스킴은 위임되지 않으므로 intent 만 유효하다.)
//   ▸ 가정(카카오 App Link 동작 — 네이티브 계약 아님, 실기기 QA 로만 검증): scheme=https + package 로
//     카톡이 pf.kakao.com/.../chat 을 해당 채널 채팅으로 착지시킨다.
//   ▸ browser_fallback_url 은 폴백 의도 기록(ExternalAppLauncher 는 자체 market 폴백을 우선한다).
const CS_CHANNEL_ANDROID_INTENT =
  `intent://pf.kakao.com/${CS_CHANNEL_PUBLIC_ID}/chat` +
  `#Intent;scheme=https;package=com.kakao.talk;` +
  `S.browser_fallback_url=${encodeURIComponent(CS_CHANNEL_WEB_URL)};end`;

/**
 * 고객센터 카카오 채널 채팅 — 문의하기 진입점 전체의 단일 핸들러.
 * AOS 는 intent:// 를 외부 위임한다. iOS 의 pf.kakao.com HTTPS 는 현재 WebView 안에서 로드되며 채널 착지는 실기기 재확인 대상이다.
 * WebView 에서는 location.href 를 사용한다(window.open/target=_blank 금지). 성공 콜백이 없어 토스트를 띄우지 않는다.
 */
export const openCsChannel = (): void => {
  switch (appType()) {
    case "Android":
      window.location.href = CS_CHANNEL_ANDROID_INTENT;
      break;
    case "iOS":
      // iOS: allowlist 미일치 https 도 WebView 안에서 로드된다(외부 위임은 비-http 스킴만). 카카오 채널 착지(UL) 여부는
      // 실기기 재확인 필요.
      window.location.href = CS_CHANNEL_WEB_URL;
      break;
    default:
      // 일반 브라우저(dev/QA) — WebView 제약 밖이라 새 창을 연다.
      window.open(CS_CHANNEL_WEB_URL, "_blank", "noopener,noreferrer");
  }
};
